import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import { initLenis } from "@/lib/scroll";

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#15181C", border: "1px solid #2A2D33", color: "#E8EAED", borderRadius: 0 } }} />
    </BrowserRouter>
  );
}

export default App;
